import React, { Component, Fragment } from "react";
import { inject, observer } from 'mobx-react';
import classnames from "classnames";
import { Button, FormGroup, Input, Label, Table, Modal, ModalHeader, ModalBody } from "reactstrap";
import { Plus, Edit, Eye, Code, Command, Search } from "react-feather";
import Select from "react-select";
import "../../../assets/scss/pages/settings.scss";
import { toast } from "react-toastify"


const typeOptions = [
  { value: "email", label: "Email" },
  { value: "page", label: "Page" },
  { value: "meeting", label: "Meeting" },
  { value: "sms", label: "SMS" }
]

@inject('templateStore')
@observer
class Templates extends Component {
  constructor(props) {
    super(props);
    this.editor = null;
    this.state = {
      usersOverlayVisible: false,
      isEditable: false,
      prevModal: false,
      prevData: '',
      saveClose: false,
      template: null
    };
  }

  componentDidMount = () => {
    const { templateStore } = this.props;
    templateStore.loadTemplates();
  }

  onChange = (e) => {
    const { templateStore } = this.props;
    templateStore.setAttribute(e.target.name, e.target.value)
  }

  onSelectChange = (attrName, e) => {
    const { templateStore } = this.props;
    templateStore.setAttribute(attrName, e.value)
  }

  handleSave = () => {
    const { templateStore } = this.props;
    templateStore.saveTemplate();
    
    this.toggleOverlay(false);
  }

  toggleOverlay = (toggle, action = "", data = false) => {
    const { templateStore } = this.props;
    if (toggle) {
      if (action === "new") {
        templateStore.loadTemplate(null);
      }
      if (action === "edit" && data) {
        templateStore.loadTemplate(data.uid);
      }
    }
    this.setState({
      isEditable: action === "edit" ? true : false,
      usersOverlayVisible: toggle
    });
  }

  render() {
    const { templateStore } = this.props;
    const { templates } = templateStore;
    const { uid, title, type, description, content, seeded } = templateStore.template;
    
    return (
      <Fragment>          
        <div className="topbar">
          <FormGroup className="position-relative mb-0" style={{ width: "30%" }}>
            <Input
              className="w-100 mr-1 mb-sm-0 search-product"
              type="text"
              placeholder="search..."
              value={this.state.searchVal}
            />
            <div className="form-control-position">
              <Search size={22} />
            </div>
          </FormGroup>
          <Button
            color="primary"
            className="btn"
            onClick={() => this.toggleOverlay(true, "new")}
          >
            <Plus size={18} />Add New
          </Button>
        </div>
        <div>
          {
            templates && templates.length
              ? <Table hover responsive>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Type</th>
                    <th>Description</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    templates.map((item, index) => {
                      return (
                        <tr key={item.title}>
                          <td>{item.title}</td>
                          <td>{item.type}</td>
                          <td>{item.description ? item.description : ""}</td>
                          <td>
                            <Edit size={16} onClick={() => this.toggleOverlay(true, 'edit', item)} />
                            {" "}
                            <Eye size={16} onClick={() => window.open(`${window.location.origin}/template/view/${item.uid}`, "_blank")} hidden={item.type == "sms"? true : false}/>
                            {" "}
                            <Code size={16} onClick={() => window.open(`${window.location.origin}/template/edit/${item.uid}`, "_blank")} hidden={item.type == "sms"? true : false}/>
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </Table> 
              : null
          }
        </div>
        <div className="animation-slider">
          {
            this.state.usersOverlayVisible
              ? <Fragment> 
                <div className="animation-slider-sidebar" style={{ width: "50vw" }}>
                  <div className="sidebar_header">
                    <span className="heading">
                      {this.state.isEditable ? "Update Template" : "Add Template"}
                    </span>
                    <div>
                      <Button
                        className="btn mr-1"
                        onClick={this.handleSave}
                        color="primary">
                        {this.state.isEditable ? "Update" : "Add"}
                        </Button>
                      <Button
                        className="btn ml-1"
                        outline
                        color="danger"
                        onClick={()=>this.toggleOverlay(false)}
                      >
                        Cancel
                        </Button>
                    </div>
                  </div>
                  <div className="sidebar_content">
                    <FormGroup>
                      <Label htmlFor="title">Title</Label>
                      <Input
                        type="text"
                        value={title}
                        name="title"
                        placeholder="Title"
                        onChange={e => this.onChange(e)}
                        id="title"
                      />
                    </FormGroup>
                    { seeded == false ? 
                      <FormGroup>
                        <Label htmlFor="type">Type</Label>
                        <Select
                          className="React"
                          classNamePrefix="select"
                          name="type"
                          options={typeOptions}
                          onChange={(e) => this.onSelectChange("type", e)}
                          id="type"
                        />
                      </FormGroup> : <div></div>}
                    <FormGroup>
                      <Label htmlFor="description">Description</Label>
                      <Input
                        type="text"
                        value={description}
                        name="description"
                        placeholder="Description"
                        onChange={e => this.onChange(e)}
                        id="description"
                      />
                    </FormGroup>
                    {
                      type == "sms" ? (
                        <FormGroup>
                          <Label htmlFor="content">Message Content</Label>
                          <Input
                            type="textarea"
                            value={content}
                            name="content"
                            placeholder="Type Message Text"
                            onChange={e => this.onChange(e)}
                            id="content"
                          />
                          <small
                            className={`counter-value float-right ${
                              content.length > 100 ? "bg-danger" : ""
                            }`}
                          >
                            {`${content.length}/140`}
                          </small>
                        </FormGroup>
                      ) : (
                        <div></div>
                      )
                    }
                    {/* <FormGroup>
                      <Label htmlFor="content">Content</Label>
                      <Input
                        type="textarea"
                        name="content"
                        id="content"
                        value={content}
                        placeholder="HTML template content"
                        onChange={(e) => this.onChange(e)}
                      />
                    </FormGroup> */}
                  </div>
                </div>
                <div
                  className={classnames("animation-slider-overlay", {
                    show: this.state.usersOverlayVisible
                  })}
                  onClick={() => this.toggleOverlay(false)}
                />
              </Fragment>
              : null
          }
        </div>
      </Fragment>
    );
  }
}

const styles = {
  imageDiv: {
    height: "60px",
    width: "60px",
    overflow: "hidden",
    borderRadius: "50%",
    border: "1px solid #cacaca"
  },
  image: {
    height: "100%",
    width: "100%",
    objectFit: "contain",
    objectPosition: "center"
  }
}

export default Templates;